import React from 'react';
import { GridColumn, GridCell } from '@progress/kendo-react-grid';
import ColumnMenu from '@hobs/components/Grid/ColumnMenu';
import ShortId from 'shortid';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import './Columns.scss';

function hasColumnFilter(array, search) {
  if (!array) {
    return null;
  }
  return array.find(item => {
    if (item.filters) {
      return hasColumnFilter(item.filters, search);
    }

    return (
      item.field === search ||
      (item.field.indexOf('.') > -1 && item.field.indexOf(search) > -1)
    );
  });
}

const Columns = ({ columns, onSave, onReset, dataState }) => {
  return Object.getOwnPropertyNames(columns).reduce((results, key) => {
    const column = columns[key];
    let filterFields = [key];

    /**
     * Collect fields which have impact for filtering
     */
    if (column.customFilter) {
      filterFields = column.customFilter.data.reduce((results, item) => {
        if (item.field && results.indexOf(item.field) === -1) {
          results.push(item.field);
        }
        return results;
      }, filterFields);
    }

    const isFilterActive = () => {
      if (dataState.filter) {
        return filterFields.reduce((result, filter) => {
          if (!result) {
            return hasColumnFilter(dataState.filter.filters, filter);
          }

          return result;
        }, false);
      }

      return false;
    };

    if (column.visible) {
      const menu = props => (
        <ColumnMenu
          onSave={onSave}
          onReset={onReset}
          {...column.columnMenu}
          customFilter={column.customFilter}
          {...props}
        />
      );
      results.push(
        <GridColumn
          key={ShortId.generate()}
          field={key}
          {...column}
          headerClassName={classnames(column.headerClassName, {
            'has-filter': isFilterActive()
          })}
          columnMenu={column.columnMenu && menu}
          cell={props => {
            if (column.cell) {
              return column.cell({
                ...props,
                render: element => {
                  return element;
                }
              });
            }

            return (
              <GridCell
                {...props}
                render={element => {
                  const newElement = {
                    ...element,
                    props: {
                      ...element.props,
                      className: classnames(
                        {
                          'cell-numeric':
                            column.filter && column.filter === 'numeric'
                        },
                        element.className
                      ),
                      onClick: () => {
                        // TODO - need to set it react way.
                        event.target.classList.toggle('expanded');
                      }
                    }
                  };

                  return newElement;
                }}
              />
            );
          }}
        />
      );
    }

    return results;
  }, []);
};

Columns.propTypes = {
  onSave: PropTypes.func,
  onReset: PropTypes.func,
  columns: PropTypes.object,
  dataState: PropTypes.object
};

export default Columns;
